<template>
<div class="form">
<a-card  size="small" :title="c_title">
    <v-gobackbutton slot="extra" >返回</v-gobackbutton>
        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item label="平台类型" ref="platformtype" prop="platformtype">
                <platformSelecter :isDisabled="!is_vue_task" :showAll="false" v-model="record.platformtype"></platformSelecter>
            </a-form-model-item>
            <a-form-model-item ref="userid" label="用户ID" prop="userid">
                <a-input
                    v-if="is_vue_task"
                    v-model="record.userid"
                     @blur="
                        () => {
                            $refs.userid.onFieldBlur();
                        }
                        "
                />
                <span v-else>{{record.userid}}</span>
            </a-form-model-item>
            <a-form-model-item ref="fullname" label="用户名称" prop="fullname">
                <a-input
                    v-if="is_vue_task"
                    v-model="record.fullname"
                     @blur="
                        () => {
                            $refs.fullname.onFieldBlur();
                        }
                        "
                />
                <span v-else>{{record.fullname}}</span>
            </a-form-model-item>
            <a-form-model-item label="业务编码"  ref="platformcode" prop="platformcode">
               <a-input
                    v-if="is_vue_task"
                    v-model="record.platformcode"
                     @blur="
                        () => {
                            $refs.platformcode.onFieldBlur();
                        }
                        "
                />
                <span v-else>{{record.platformcode}}</span>
            </a-form-model-item>

            <a-form-model-item ref="tags" label="用户标签" prop="tags">
                <a-input
                    v-if="is_vue_task"
                    v-model="record.tags"
                     @blur="
                        () => {
                            $refs.tags.onFieldBlur();
                        }
                        "
                />
                <span v-else>{{record.tags}}</span>
            </a-form-model-item>

            <a-form-model-item ref="phone" label="手机号" prop="phone">
                <a-input
                    v-if="is_vue_task"
                    v-model="record.phone"
                     @blur="
                        () => {
                            $refs.phone.onFieldBlur();
                        }
                        "
                />
                <span v-else>{{record.phone}}</span>
            </a-form-model-item>

            <a-form-model-item ref="email" label="邮箱" prop="email">
                <a-input
                    v-if="is_vue_task"
                    v-model="record.email"
                     @blur="
                        () => {
                            $refs.email.onFieldBlur();
                        }
                        "
                />
                <span v-else>{{record.email}}</span>
            </a-form-model-item>

<!--             <a-form-model-item label="修改信息" v-if="!is_new">
                    创建时间 ：<span>{{record.createtime}}</span>
                    创建人:<span>{{record.createuser}}</span>
                    <br>
                    更新时间: <span>{{record.updatetime}}</span>
                    更新人: <span>{{record.updatetuser}}</span>
            </a-form-model-item> -->

            <a-form-model-item v-show="is_vue_task"  :wrapper-col="{ span: 14, offset: 8 }" >
                <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" @click="handleCancel">
                    取消
                </a-button>
            </a-form-model-item>
        </a-form-model>

 </a-card>
</div>

</template>
<script>
import platformSelecter from '../../components/platformSelecter'
const m_title = {
    'add_user':'新增用户',
    'detail_user':'查看用户',
    'edit_user':'编辑用户',
};


export default {
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                userid: [
                    { required: true, message: '请输入用户编码', trigger: 'blur' },
                    { min: 1, max: 25, message: '请输入1~25个字符', trigger: 'blur' },
                    {validator:this.handleConfirmPass}
                ],
                fullname: [
                    { required: false, message: ' 请输用户名称 ', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                platformcode: [
                    { required: false, message: ' 请输入平台编码 ', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                platformtype: [
                    { required: true, message: ' 请选择平台类型', trigger: 'blur' },
                ],
                
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            isuseridDuppled:false,
            record:{
                id:'',
                userid:'',
                fullname:'',
                platformcode:'',
                platformtype:'',
                tag:''
            }
        };
    },
    components:{
        platformSelecter
    },
    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    const { params } = this.$route;
                    
                    if(params.action == 'edit_user'){
                        this.$store
                            .dispatch({
                                type: "mcmsmanager/updatetargetgroups",
                                params: this.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    this.handleCancel();
                                    this.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'add_user'){
                        this.record.id = '';
                        //新增
                        this.$store
                            .dispatch({
                                type: "mcmsmanager/addtargetgroups",
                                params: this.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    this.handleCancel();
                                }
                                else if(response.data.errorCode == 'param.error'){
                                    this.isuseridDuppled = true;
                                    this.triggerValidate();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        triggerValidate(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    console.log(valid)
                }
            })
            this.confirmLoading = false;
            this.isuseridDuppled = false;
        },
        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

        getDetail(id){
            this.$store.dispatch({
                type: "mcmsmanager/querytargetgroupsone",
                params: {
                    id:id,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.record = {
                        ...result
                    }
                }
            });
        },
        handleConfirmPass(rule,value, callback){
            if (this.isuseridDuppled) {
                callback('编码已经存在！')
            }
            // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
            callback()
        }

    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "add_user";
        if (!this.is_new) {
            this.getDetail(query.id)
        }
        else{
            this.resetForm();
        }
        this.is_vue_task = params.action != 'detail_user'
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
